/*
  Pet Wants — live storefront touches.
  Loaded with defer *before* global.js in <head>: it runs once the markup is
  parsed but before Dawn upgrades slider components, so the reorder happens
  before sliders measure their slides.

  1. Shuffle product grids (home, and collections left on default sort).
  2. Hero collage shows 3 random products from the showcase list.
  3. Product-card photos start on a random image and crossfade to the next
     image while on screen, and again whenever a card scrolls back into view.
  4. Cart icon bounce + "fly to cart" when something is added.
  Reduced-motion users keep the shuffle and random start image, but get no
  crossfades or flying images.
*/
(function () {
  var script = document.currentScript;
  var template = (script && script.dataset.template) || '';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  /* ---------- 1. Shuffle grids ---------- */
  var sorted = /[?&]sort_by=/.test(location.search);
  var shuffleHere = template === 'index' || (template === 'collection' && !sorted);
  if (shuffleHere) {
    document.querySelectorAll('ul.product-grid, .pm-probs__grid').forEach(function (list) {
      var kids = Array.prototype.filter.call(list.children, function (li) {
        return li.querySelector('.product-card-wrapper, .pm-prob__link');
      });
      if (kids.length < 2) return;
      var tail = Array.prototype.filter.call(list.children, function (li) { return kids.indexOf(li) === -1; });
      list.style.overflowAnchor = 'none';
      shuffle(kids).concat(tail).forEach(function (li, i) {
        list.appendChild(li);
        if (li.style.getPropertyValue('--animation-order')) li.style.setProperty('--animation-order', i + 1);
      });
      // Sliders were already laid out; keep them on the first slide after the reorder.
      list.scrollLeft = 0;
      requestAnimationFrame(function () { list.scrollLeft = 0; });
    });
  }

  /* ---------- 2. Hero collage ---------- */
  document.querySelectorAll('[data-pm-collage]').forEach(function (box) {
    var tiles = Array.prototype.slice.call(box.querySelectorAll('.pm-hero__tile'));
    if (tiles.length <= 3) return;
    var pick = shuffle(tiles.slice()).slice(0, 3);
    tiles.forEach(function (t) {
      t.classList.remove('pm-hero__tile--1', 'pm-hero__tile--2', 'pm-hero__tile--3');
      var k = pick.indexOf(t);
      if (k === -1) { t.hidden = true; return; }
      t.hidden = false;
      t.classList.add('pm-hero__tile--' + (k + 1));
      var img = t.querySelector('img'); if (img) img.loading = 'eager';
    });
    pick.forEach(function (t) { box.appendChild(t); });
  });

  /* ---------- 3. Card photos ---------- */
  function srcset(u) {
    if (!/[?&]width=\d+/.test(u)) return '';
    return [360, 533, 720, 940].map(function (w) {
      return u.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }
  function setBase(img, u) {
    var s = srcset(u);
    if (s) img.srcset = s; else img.removeAttribute('srcset');
    img.src = u;
  }

  var cards = [];
  document.querySelectorAll('.pm-rot[data-pm-imgs]').forEach(function (r) {
    var urls = (r.dataset.pmImgs || '').split('|').filter(Boolean);
    var base = r.parentNode && r.parentNode.querySelector('.media > img');
    if (urls.length < 2 || !base) return;
    var c = { r: r, base: base, urls: urls, i: Math.floor(Math.random() * urls.length), seen: false, busy: false, visible: false };
    if (c.i) setBase(base, urls[c.i]);
    cards.push(c);
  });

  // Shoppers need time to recognise a product, so every photo stays put for a
  // while before the next one fades in.
  var MIN_DWELL = 8000;
  function advance(c, dwell) {
    if (c.busy) return;
    if (Date.now() - (c.last || 0) < (dwell || MIN_DWELL)) return;
    var wrap = c.r.closest('.card-wrapper');
    if (wrap && (wrap.matches(':hover') || wrap.hasAttribute('data-pm-pinned'))) return;
    c.busy = true;
    c.last = Date.now();
    var next = (c.i + 1) % c.urls.length, u = c.urls[next];
    var over = c.r.querySelector('img');
    if (!over) { over = document.createElement('img'); over.alt = ''; c.r.appendChild(over); }
    var pre = new Image();
    pre.onload = function () {
      over.src = u;
      c.r.classList.add('is-on');
      setTimeout(function () {
        setBase(c.base, u);
        c.i = next;
        var done = function () { c.r.classList.add('is-snap'); c.r.classList.remove('is-on'); setTimeout(function () { c.r.classList.remove('is-snap'); c.busy = false; }, 60); };
        if (c.base.decode) c.base.decode().then(done, done); else setTimeout(done, 400);
      }, 1150);
    };
    pre.onerror = function () { c.busy = false; };
    pre.src = u;
  }

  if (!reduce && cards.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var c = e.target._pm;
        if (!c) return;
        if (e.isIntersecting) {
          c.visible = true;
          // Back in view after scrolling: show the next photo, but not if it changed moments ago.
          if (c.seen) setTimeout(function () { advance(c, 4000); }, 900 + Math.random() * 700);
          else c.last = Date.now();
          c.seen = true;
        } else {
          c.visible = false;
        }
      });
    }, { threshold: 0.55 });
    cards.forEach(function (c) { c.r._pm = c; io.observe(c.r); });

    setInterval(function () {
      if (document.hidden) return;
      var vis = cards.filter(function (c) { return c.visible && !c.busy && Date.now() - (c.last || 0) >= MIN_DWELL; });
      shuffle(vis).slice(0, 1).forEach(function (c) { advance(c); });
    }, 4500);
  }

  /* ---------- 4b. Colour swatches on cards ---------- */
  // Hover or tap a swatch: the card photo switches to that colour and the card
  // links straight to that variant. The photo then stops rotating.
  function pickSwatch(btn) {
    var wrap = btn.closest('.card-wrapper');
    if (!wrap || btn.getAttribute('aria-pressed') === 'true') return;
    var base = wrap.querySelector('.card__media .media > img');
    if (base && btn.dataset.img) setBase(base, btn.dataset.img);
    var rot = wrap.querySelector('.pm-rot');
    if (rot) rot.classList.remove('is-on');
    wrap.setAttribute('data-pm-pinned', '');
    Array.prototype.forEach.call(btn.parentNode.querySelectorAll('.pm-sw'), function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    if (btn.dataset.url) {
      Array.prototype.forEach.call(wrap.querySelectorAll('a[href*="/products/"]'), function (a) { a.href = btn.dataset.url; });
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.pm-sw');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    pickSwatch(b);
  });
  document.addEventListener('mouseover', function (e) {
    var b = e.target.closest && e.target.closest('.pm-sw');
    if (b) pickSwatch(b);
  });

  /* ---------- 4. Cart feedback ---------- */
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble && 'MutationObserver' in window) {
    new MutationObserver(function () {
      bubble.classList.remove('pm-bump');
      void bubble.offsetWidth;
      bubble.classList.add('pm-bump');
    }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  if (!reduce && bubble) {
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      // Dawn nests a <section class="product__info-container"> inside product-info, so look outward explicitly.
      var scope = form.closest('.card-wrapper') || form.closest('product-info') || form.closest('.shopify-section') || document;
      var src = scope.querySelector('.card__media .media > img, .product__media-item.is-active img, .product__media img');
      if (!src || !src.getBoundingClientRect || !document.body.animate) return;
      var a = src.getBoundingClientRect(), b = bubble.getBoundingClientRect();
      if (!a.width || !b.width) return;
      var fly = src.cloneNode(false);
      fly.removeAttribute('srcset'); fly.removeAttribute('loading'); fly.removeAttribute('id');
      fly.src = src.currentSrc || src.src;
      fly.className = 'pm-fly';
      fly.alt = '';
      var size = Math.min(a.width, a.height, 220);
      fly.style.cssText = 'left:' + (a.left + (a.width - size) / 2) + 'px;top:' + (a.top + (a.height - size) / 2) + 'px;width:' + size + 'px;height:' + size + 'px;';
      document.body.appendChild(fly);
      var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
      fly.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 0.95 },
        { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 60) + 'px) scale(.5)', opacity: 0.9, offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08)', opacity: 0.2 }
      ], { duration: 800, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = function () { fly.remove(); };
    }, true);
  }
})();
